export const APP_CONFIG = {
  name: 'Cates Roofing & Contracting',
  tagline: 'Excellence in Every Shingle',
  description: 'A family-owned roofing company with four generations of roofing experience, premium materials, experienced, reliable crews, and craftsmanship we stand behind. ',
  phone: '(904) 855-9186',
  phoneRaw: '9048559186',
  email: 'info@catesroofing.com',
  emailSupport: 'support@catesroofing.com',
  address: '4184 Ripken Cir E',
  city: 'Jacksonville',
  state: 'FL',
  zip: '32224',
  region: 'Northeast Florida',
  ownership: 'Locally & Family Owned',
  // Average contract value — roofing in Florida is a significant investment.
  // Do not position the site on affordability or lowest price.
  averageContract: '$35,000',
  marketPositioning: "Jacksonville's Premium Roof Replacement & Insurance Claim Specialists",
  website: 'https://catesroofing.com',
  socialLinks: {
    facebook: 'https://facebook.com/catesroofing',
    instagram: 'https://instagram.com/catesroofing',
    twitter: 'https://twitter.com/catesroofing',
    linkedin: 'https://linkedin.com/company/catesroofing',
    youtube: 'https://youtube.com/@catesroofing',
  },
  businessHours: {
    weekdays: '7:00 AM – 7:00 PM',
    saturday: '8:00 AM – 5:00 PM',
    sunday: 'Emergency Only',
  },
  // Florida certified roofing contractor licence. Verifiable on the DBPR licensee
  // portal — keep this exact and current; it is a regulated advertising claim.
  //
  // CCC1337870 per the client's written round-4 brief, reconfirmed 2026-08-17.
  // (An earlier verbal value of CCC1331585 was superseded.) This is a regulated
  // advertising claim — verify on the Florida DBPR licensee portal before launch
  // and do not change without written confirmation from Mark Cates.
  licenseNumber: 'CCC1337870',
  licenses: ['FL Lic. #CCC1337870', 'Owens Corning Preferred Contractor'],

  // Manufacturer credential. Cates is an Owens Corning **Preferred** Contractor —
  // NOT Platinum Preferred (client correction 2026-08-17). The "only 1% of
  // contractors" figure belongs to the Platinum tier and must not be used.
  certification: {
    name: 'Owens Corning Preferred Contractor',
    shortName: 'Owens Corning Preferred',
    exclusivity: 'Factory-certified and installed to Owens Corning specification',
    exclusivityShort: 'Factory-Certified Contractor',
  },

  // Google reputation — surfaced as a primary trust element, not a footnote.
  // reviewCount must be the real Google total before go-live; an inflated
  // review count is an advertising-compliance problem, not a copy choice.
  reputation: {
    rating: '5.0',
    ratingStars: 5,
    reviewCount: '100+',
    source: 'Google',
  },

  // Wording locked by Mark Cates: "Free Estimates", never "Free Quotes".
  estimateLabel: 'Free Estimate',
  estimateLabelPlural: 'Free Estimates',
  warranty: {
    workmanship: '10 Years',
    materials: 'Up to 50 Years (manufacturer)',
  },
  financing: {
    available: true,
    minAmount: 500,
    maxMonths: 60,
    rate: '0% for 18 months',
  },
  emergencyAvailable: true,
  familyBusinessLegacySince: 1926,

  // Hero background media.
  // heroVideoUrl: '' renders the still image alone. To use Cates' own drone footage,
  // drop the file at public/media/hero.mp4 and set this to '/media/hero.mp4'.
  // Never point this at a third party's site — the previous value hot-linked a
  // competitor's branded clip from their own server.
  heroVideoUrl: '',
  heroImageUrl: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1800&auto=format&fit=crop&q=80',
};

export const ROUTES = {
  // Public
  HOME: '/',
  SERVICES: '/services',
  SERVICE_DETAIL: '/services/:slug',
  GALLERY: '/gallery',
  TESTIMONIALS: '/testimonials',
  ABOUT: '/about',
  CONTACT: '/contact',
  QUOTE: '/get-quote',
  BLOG: '/blog',
  BLOG_POST: '/blog/:slug',
  FAQ: '/faq',
  FINANCING: '/financing',
  SERVICE_AREAS: '/service-areas',
  EMERGENCY: '/emergency',
  CAREERS: '/careers',
  PRIVACY: '/privacy',
  TERMS: '/terms',

  // Auth
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',

  // Customer Portal
  CUSTOMER: '/portal',
  CUSTOMER_DASHBOARD: '/portal/dashboard',
  CUSTOMER_REQUESTS: '/portal/requests',
  CUSTOMER_QUOTES: '/portal/quotes',
  CUSTOMER_APPOINTMENTS: '/portal/appointments',
  CUSTOMER_PROJECTS: '/portal/projects',
  CUSTOMER_INVOICES: '/portal/invoices',
  CUSTOMER_DOCUMENTS: '/portal/documents',
  CUSTOMER_PROFILE: '/portal/profile',
  CUSTOMER_NOTIFICATIONS: '/portal/notifications',

  // Admin Portal
  ADMIN: '/admin',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_LEADS: '/admin/leads',
  ADMIN_CUSTOMERS: '/admin/customers',
  ADMIN_APPOINTMENTS: '/admin/appointments',
  ADMIN_PROJECTS: '/admin/projects',
  ADMIN_QUOTES: '/admin/quotes',
  ADMIN_INVOICES: '/admin/invoices',
  ADMIN_CONTRACTORS: '/admin/contractors',
  ADMIN_TEAM: '/admin/team',
  ADMIN_REPORTS: '/admin/reports',
  ADMIN_SETTINGS: '/admin/settings',
  ADMIN_AUDIT: '/admin/audit',
  ADMIN_ROLES: '/admin/roles',
  ADMIN_BLOG: '/admin/blog',
  ADMIN_CMS: '/admin/cms',

  // Contractor Portal
  CONTRACTOR: '/contractor',
  CONTRACTOR_DASHBOARD: '/contractor/dashboard',
  CONTRACTOR_JOBS: '/contractor/jobs',
  CONTRACTOR_SCHEDULE: '/contractor/schedule',
  CONTRACTOR_EARNINGS: '/contractor/earnings',
  CONTRACTOR_PROFILE: '/contractor/profile',
  CONTRACTOR_DOCUMENTS: '/contractor/documents',
};

export const FEATURE_FLAGS = {
  CHATBOT: false,
  SMS_INTEGRATION: false,
  PAYMENT_PORTAL: true,
  MULTI_TENANT: false,
  AI_ESTIMATES: false,
  DRONE_INSPECTION: false,
};

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
};
